import React from "react";
import loading from "../img/loading.gif";

const LoadingSkeleton = () => {
  return (
    <div className="skeleton">
      <div className="loader" title="Overview logo">
        <img className="loader" src={loading} alt="loading" />
      </div>
    </div>
  );
};
export default LoadingSkeleton;
